<!--<div [ngClass]="{'first':activeIdx == 0 || activeIdx == 6,'last':activeIdx == 2 || activeIdx == 8}">

<ngb-carousel #alCarousel (slide)="onSlide($event)" [wrap]="false" [showNavigationArrows]="true" [showNavigationIndicators]="true" [activeId]="0" [keyboard]="true" >
  <ng-template ngbSlide>
    <div style="object-fit: contain; width: fit-content; height: fit-content;">
      <img src="../../../assets/img/applied-load-guide/[Mobile View - pg. 1] Applied Load - 1.5kW (1).png" style="padding-left: 15.5%; width: 295px; height: 450px;">
    </div>
  </ng-template>
  <ng-template ngbSlide>
    <div style="object-fit: contain; width: fit-content; height: fit-content;">
      <img src="../../../assets/img/applied-load-guide/[Mobile View - pg. 2] Applied Load - 3kW (1).png" style="padding-left: 15.5%; width: 295px; height: 450px;">
    </div>
  </ng-template>
  <ng-template ngbSlide>
    <div style="object-fit: contain; width: fit-content; height: fit-content;">
      <img src="../../../assets/img/applied-load-guide/mobile_page3.jpg" style="padding-left: 15.5%; width: 295px; height: 450px;">
    </div>
  </ng-template>
</ngb-carousel>

</div>-->

<div id="carouselAppliedLoadGuide" class="carousel slide" data-bs-ride="false" data-bs-wrap="false" data-bs-touch="true">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <div class="image-overlay" [ngClass]="{ 'focused': focused }" (touchstart)="onOverlayTouchStart($event)"></div>
      <div class="image-focus" [ngClass]="{ 'focused': focused }" (click)="toggleFocus($event)" (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
        <div class="image-container" [ngClass]="{ 'focused': focused }">
          <img src="assets/img/applied-load-guide/[Mobile View - pg. 1] Applied Load - 1.5kW (1).png" data-image-id="0" alt="Focused Image">
        </div>
      </div>
    </div>
    <div class="carousel-item">
      <div class="image-overlay" [ngClass]="{ 'focused': focused }" (touchstart)="onOverlayTouchStart($event)"></div>
      <div class="image-focus" [ngClass]="{ 'focused': focused }" (click)="toggleFocus($event)" (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
        <div class="image-container" [ngClass]="{ 'focused': focused }">
          <img src="assets/img/applied-load-guide/[Mobile View - pg. 2] Applied Load - 3kW (1).png" data-image-id="1">
        </div>
      </div>
    </div>
    <div class="carousel-item">
      <div class="image-overlay" [ngClass]="{ 'focused': focused }" (touchstart)="onOverlayTouchStart($event)"></div>
      <div class="image-focus" [ngClass]="{ 'focused': focused }" (click)="toggleFocus($event)" (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
        <div class="image-container" [ngClass]="{ 'focused': focused }">
          <img src="assets/img/applied-load-guide/mobile_page3.jpg" data-image-id="2">
        </div>
      </div>
    </div>
  </div>
  @if (activeIdx != 0) {
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselAppliedLoadGuide" (click)="onSlidePrev($event)" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="false"></span>
      <span class="visually-hidden">Previous</span>
    </button>
  }
  @if (activeIdx != 2) {
    <button class="carousel-control-next" type="button" data-bs-target="#carouselAppliedLoadGuide" (click)="onSlideNext($event)" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="false"></span>
      <span class="visually-hidden">Next</span>
    </button>
  }
  <br>
    <br>
      <div class="carousel-indicators">
        <button type="button" data-bs-target="#carouselAppliedLoadGuide" data-bs-slide-to="0" class="active" aria-current="true"></button>
        <button type="button" data-bs-target="#carouselAppliedLoadGuide" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#carouselAppliedLoadGuide" data-bs-slide-to="2" aria-label="Slide 3"></button>
      </div>
    </div>

